/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import LiveTvOutlinedIcon from '@material-ui/icons/LiveTvOutlined';
import './navbar.css';

export default [
  {
    subheader: 'LIVE CLASS Schedule',
    items: [
      {
        title: 'Your Live Classes',
        href: '/live-classes',
        icon: LiveTvOutlinedIcon,
        roles: ['INSTRUCTOR'],
      },
    ],
  },
];
